import {isNil} from 'ramda';

import {GetAllEnumsResponse} from '../../../types/api/api';
import {findRootKeyInFeatureTree} from './findRootKeyInFeatureTree';
import {findSelectedKeyInFieldUnderFeatureSubtree} from './findSelectedKeyInFieldUnderFeatureSubtree';

export function toggleFeatureSelection(
  currentValue: string[] | null | undefined,
  value: string,
  features: GetAllEnumsResponse[number]['keys']
): string[] {
  if (isNil(currentValue)) {
    return [value];
  }

  const isSelected = currentValue.includes(value);
  const rootKey = findRootKeyInFeatureTree(value, features);
  const selectedValueInTree = findSelectedKeyInFieldUnderFeatureSubtree(
    rootKey,
    currentValue,
    features
  );

  return isSelected
    ? currentValue.filter((item) => item !== value)
    : [...currentValue, value].filter((item) => item !== selectedValueInTree);
}
